import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    API_ROLE_URL = config.serverAddress + ':' + config.serverPort + '/role/';

    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get(this.API_ROLE_URL + 'all');
    }
}